import {DefaultInteraction} from "./interaction";


export class TeleportMetaversePrompt extends DefaultInteraction {

	key() {
		return "teleport_to_metaverse"
	}

	interact(interactionData, metadata, onSuccess, onError) {
		console.log(`Interaction::${this.key()} - Run`, interactionData, metadata)

		this._emitTeleportEvent(interactionData.metaverse_addr)

		return true
	}


	onProximityExit(interactable) {
		window.dispatchEvent(new CustomEvent('interaction-out', {
			detail: {
				action_type: this.key(),
			}
		}))
	}


	onProximityEnter(interaction, interactable) {
		this.interact(interaction.data, {}, null, null)
	}

	_emitTeleportEvent(metaverseAddr) {
		window.dispatchEvent(new CustomEvent('interaction-ui', {
			detail: {
				action_type: this.key(),
				data: {
					metaverse_addr: metaverseAddr
				}
			}
		}))
	}
}